var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseCaseOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4069 30L16.6709 29L20.6709 22H26.6709C27.7779 22 28.6709 21.107 28.6709 20V8C28.6709 6.893 27.7779 6 26.6709 6H6.6709C5.5639 6 4.6709 6.893 4.6709 8V20C4.6709 21.107 5.5639 22 6.6709 22H15.6709V24H6.6709C4.4619 24 2.6709 22.21 2.6709 20V8C2.6709 5.789 4.4619 4 6.6709 4H26.6709C28.8809 4 30.6709 5.789 30.6709 8V20C30.6709 22.21 28.8809 24 26.6709 24H21.8359L18.4069 30Z",
    fill: "#F67E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 8L18.579 11.703L22.667 12.297L19.667 15L20.667 19L16.667 16.75L12.666 19L13.667 15L10.667 12.297L14.867 11.703L16.667 8Z",
    fill: "#F67E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseOther);
export default __webpack_public_path__ + "static/media/use-case-other.0d1a19ef459177e94aa2959e55b6db55.svg";
export { ForwardRef as ReactComponent };